// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9357":"1bd95b5a858d1212","23933":"61b4c9334f43ec3a","50000":"e8dec7efcdc6dc08","60957":"6cfff3f53e02ad24","96325":"635140f8675d1ec5"}[chunkId] + ".css";
};